/**
 * 利用規約の本文（モーダル・利用規約ページで共通利用）
 */
export interface TermsArticle {
  id: string;
  title: string;
  paragraphs: string[];
}

export const TERMS_TITLE = '利用規約';

export const termsArticles: TermsArticle[] = [
  {
    id: 'art1',
    title: '第1条（適用）',
    paragraphs: [
      '本利用規約（以下「本規約」といいます。）は、運営者（※運営会社情報は「特定商取引法に基づく表記」に記載）と本サービス利用者（以下「ユーザー」といいます。）との間における「reuse-PACO」（以下「本サービス」といいます。）の利用条件を定めるものです。',
    ],
  },
  {
    id: 'art2',
    title: '第2条（定義）',
    paragraphs: [
      '1. 「本サービス」とは、セカストオンラインにおける商品の入荷を検知し、Discordサーバー上にて入荷通知を行うサービスを意味します。',
      '2. 「利用契約」とは、本規約に基づき本サービスの利用に関して運営者とユーザーとの間で締結される契約をいいます。',
    ],
  },
  {
    id: 'art3',
    title: '第3条（利用登録）',
    paragraphs: [
      '1. ユーザーは、本規約に同意の上、運営者が定める方法により利用登録の手続きを行うものとします。登録手続きに必要な情報の詳細は、本サービスのウェブサイト上にて別途ご案内されます。',
      '2. 運営者は、ユーザーから提供された登録情報に虚偽や不備がある場合、または過去に本規約違反等により不適切と判断した場合、利用登録を承認しないことがあります。',
    ],
  },
  {
    id: 'art4',
    title: '第4条（利用料金および支払方法）',
    paragraphs: [
      '1. 本サービスは、運営者が定める月額サブスクリプション制に基づき提供されます。なお、利用プランの内容及び構成は、運営者の判断により随時変更されることがあり、その際は最新の情報がウェブサイト上に公示されます。',
      '2. 利用料金、支払方法その他の詳細事項は、運営者によりウェブサイト上で随時公示されるものとします。',
      '3. 運営者は、本サービスの運営上又は市場状況の変動等に伴い、利用料金を変更することができるものとします。料金の変更がある場合、運営者はその変更内容及び適用開始日をウェブサイト上に予め公示します。なお、既に支払済みの料金に関しては、原則として返金等の対応は行いません。',
      '4. ユーザーが利用料金の支払いを遅滞した場合、ユーザーは、支払期日の翌日から支払済みに至るまで、年14.6%（年365日の日割計算）の割合による遅延損害金を運営者に支払うものとします。なお、本項は第8条第3項に基づく本サービスの提供停止その他の措置を妨げるものではありません。',
    ],
  },
  {
    id: 'art5',
    title: '第5条（ユーザーIDおよびパスワードの管理）',
    paragraphs: [
      'ユーザーは、自己の責任において、本サービスのアクセスに必要な情報（ユーザーID、パスワード等）を適切に管理し、第三者に譲渡、貸与または共有してはなりません。これに起因して生じた損害について、運営者は一切の責任を負いません。',
    ],
  },
  {
    id: 'art6',
    title: '第6条（禁止事項）',
    paragraphs: [
      'ユーザーは、本サービスの利用に際し、以下の行為を行ってはなりません。',
      '1. 法令または公序良俗に違反する行為',
      '2. 犯罪行為に関連する行為',
      '3. 本サービスの運営や他のユーザーの利用を妨害する行為',
      '4. 運営者の許可なく本サービスのシステムに不正にアクセスする行為',
      '5. その他、運営者が不適切と判断する行為',
    ],
  },
  {
    id: 'art7',
    title: '第7条（商品入荷通知と送信方法）',
    paragraphs: [
      '1. 運営者は、セカストオンラインにおける商品の入荷が確認されたタイミングで、Discordサーバーを通じて入荷通知を送信します。',
      '2. 通知対象の商品やカテゴリは特に限定されません。',
    ],
  },
  {
    id: 'art8',
    title: '第8条（通知の解除・設定変更、利用停止および退会）',
    paragraphs: [
      '1. ユーザーが本サービスに関する通知の解除または設定変更を希望する場合は、運営者まで直接ご連絡ください。',
      '2. ユーザーは、運営者の定める手続に従い、本サービスの利用契約を解除または退会することができます。',
      '3. ユーザーが利用料金の支払いを行わず、運営者が定める期限までに入金が確認できない場合、運営者は事前の通知を要せず、当該ユーザーに対する本サービスの提供を停止し、Discordサーバーからの除外その他利用契約を解除するために必要な措置を講じることができるものとします。',
    ],
  },
  {
    id: 'art9',
    title: '第9条（サービス提供の変更・中断・停止）',
    paragraphs: [
      '1. 運営者は、システムの保守、天災その他の不可抗力、または緊急時の対応のため、事前の通知なく本サービスの全部または一部の提供を中断または停止することがあります。',
      '2. 本サービスの内容および仕様は、運営者の判断により予告なく変更される場合があります。',
    ],
  },
  {
    id: 'art10',
    title: '第10条（免責事項）',
    paragraphs: [
      '1. 運営者は、本サービスに関して、その正確性、完全性、有効性、安全性等を明示的にも黙示的にも保証するものではありません。',
      '2. 商品入荷通知が必ずしも商品の確実な入荷を保証するものではなく、通知の遅延、誤送信、システム障害等により生じた損害について、運営者は一切の責任を負いません。',
    ],
  },
  {
    id: 'art11',
    title: '第11条（個人情報の取り扱い）',
    paragraphs: [
      '1. 運営者は、本サービスの利用に際して、ユーザーのDiscordアカウント情報、連絡先情報、及び利用状況などの個人情報を収集する場合があります。',
      '2. これらの個人情報は、サービス向上、安全な運営、及び問い合わせ対応を目的として利用されます。',
      '3. 運営者は、これらの情報を運営者のプライバシーポリシーに従い適切に管理し、利用目的の範囲外での利用や、ユーザーの事前同意なく第三者への提供、譲渡を行いません。ただし、法令に基づく場合や利用者の安全・本サービスの運営上必要な場合はこの限りではありません。',
      '4. また、利用者からの情報開示の請求があった場合、運営者は速やかに対応いたします。',
    ],
  },
  {
    id: 'art12',
    title: '第12条（通知または連絡）',
    paragraphs: [
      'ユーザーと運営者との間の通知または連絡は、運営者が別途定める方法により行われ、運営者が指定した連絡先に送信された時点でユーザーに到達したものとみなされます。',
    ],
  },
  {
    id: 'art13',
    title: '第13条（権利義務の譲渡の禁止）',
    paragraphs: [
      'ユーザーは、運営者の事前の書面による承諾なく、利用契約上の地位または本規約に基づく権利義務を第三者に譲渡または担保に供してはなりません。',
    ],
  },
  {
    id: 'art14',
    title: '第14条（利用規約の変更）',
    paragraphs: [
      '運営者は、ユーザー個別の同意を要せず、本規約を変更することができます。変更後の規約は、運営者が適切と判断した方法により通知または掲示された時点から効力を生じます。',
    ],
  },
  {
    id: 'art15',
    title: '第15条（準拠法・裁判管轄）',
    paragraphs: [
      '本規約の解釈および適用については日本法が適用され、本サービスに関して生じた紛争については、運営者の所在地を管轄する裁判所を第一審の専属的合意管轄裁判所とします。',
    ],
  },
];

export const termsClosing = '以上';

/** 規約の改定履歴。新しいものを先頭に追加する */
export const termsRevisions: string[] = ['2026年10月1日 改定'];
